import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { UpdateGroupAdditionalData, UpdateGroupResponse } from "./updateGroupAdditionalData";

export const updateGroupClassicUserRoleActionTypes = createRequestActionTypes('UPDATE_GROUP_CLASSIC_USER_ROLE')

export type UpdateGroupClassicUserRoleRequestBody = { 
    collectionId: number
    userId: number
    userRole: 0 | 1 
}
export type UpdateGroupClassicUserRoleAdditionalData = UpdateGroupAdditionalData & {
    bodyInfo: UpdateGroupClassicUserRoleRequestBody
}

export const updateGroupClassicUserRole = (config: ApiConfig) => (collectionId: number, bodyInfo: UpdateGroupClassicUserRoleRequestBody) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<UpdateGroupResponse, UpdateGroupClassicUserRoleRequestBody, UpdateGroupClassicUserRoleAdditionalData> = {
        method: 'POST',
        requestActionTypes: updateGroupClassicUserRoleActionTypes,
        url: `${config.API_URL}/groups/updateUserRole`,
        actionAdditionalData: {
            collectionId,
            bodyInfo
        },
        body: bodyInfo
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}